import { NODE_TYPES } from "src/components/NodeVisualizer/consts";
import { DIFF_TYPES } from "src/components/OrgChart/context/utils/getCalculatedState";

export const createNode = (id, data, type, parentIdOverride = null) => {
  const diffType =
    data?.diff?.[parentIdOverride ?? data?.directParentId]?._type;
  const isExpandable = ![DIFF_TYPES.MOVED_OUT, DIFF_TYPES.REMOVED].includes(
    diffType
  );

  const nodeId = isExpandable ? id : `${id}${diffType ? `-${diffType}` : ""}`;

  const node = {
    id: nodeId,
    isExpandable,
    data: { ...data, diffType, isExpandable },
    type,
    position: { x: 0, y: 0 },
  };

  if (data?.isAnchor) {
    node.isAnchor = true;
  }

  return node;
};

/**
 * @param {string} id
 * @param {string|React.node} label
 * @param {object} data
 */
export const createCollectionNode = (id, label, data = {}) => {
  return createNode(
    id,
    {
      id,
      label,
      items: [],
      itemsCount: 0,
      itemsMax: 0,
      itemsLoading: 0,
      ...data,
    },
    NODE_TYPES.COLLECTION_NODE
  );
};

export const getCreatableNodeTypes = ({
  groupType,
  isGroupedBySupplyOrDemand,
  group,
  canAllocateMembers,
}) => {
  if (
    (groupType?.isSupply && !isGroupedBySupplyOrDemand) ||
    group.id === "unallocated"
  ) {
    return [];
  }

  return [
    { type: NODE_TYPES.CREATE_PERSON_NODE, canCreate: canAllocateMembers },
  ];
};

export const createEdge = (source, target, type = "smoothstep") => ({
  id: `${source}->${target}`,
  source,
  target,
  type,
});
